module.exports = __webpack_public_path__ + "static/media/en_badge_web_generic@2x.aa85ef5b.png";